<template>
  <!-- ImageCropField component manage to state with the whole form model -->
  <ImageCropField v-model="context.value.value" v-bind="props" />
</template>

<script setup lang="ts">
import { useFormKitContext } from '@formkit/vue'

import ImageCropField from '../ImageCropField.vue'
import type { SchemaFormKitProps } from './types'

const props = defineProps<SchemaFormKitProps>()
const context = useFormKitContext()
</script>
